import React from 'react';
import PageTemplate from '../../components/Common/PageTemplate';
import { useTranslation } from 'react-i18next';

const StrategicPlan = () => {
  const { t } = useTranslation();

  return (
    <PageTemplate title={t('strategic_plan.title')}>
      <div className="prose prose-lg max-w-none">
        <div className="mb-8">
          <p className="text-gray-700 leading-relaxed mb-6">
            {t('strategic_plan.p1')}
          </p>
          
          <p className="text-gray-700 leading-relaxed mb-6">
            {t('strategic_plan.p2')}
          </p>

          <p className="text-gray-700 leading-relaxed mb-6">
            {t('strategic_plan.p3')}
          </p>
        </div>

        <div className="bg-gray-50 p-6 rounded-lg border border-gray-200 mb-8">
          <h2 className="text-2xl font-semibold text-hacettepe-blue mb-6">{t('strategic_plan.our_strategic_plans')}</h2>
          <div className="space-y-4">
            <a 
              href="https://fs.hacettepe.edu.tr/fenyeni/dosyalar/Stratejik%20Planlar/Stratejik%20Plan%202023-2027.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="block p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow border border-gray-100"
            >
              <h3 className="text-xl font-semibold text-hacettepe-red">{t('strategic_plan.plan_2023_2027')}</h3>
              <p className="text-gray-600 mt-1">{t('strategic_plan.current_plan')}</p>
            </a>

            <a 
              href="https://fs.hacettepe.edu.tr/fenyeni/dosyalar/Stratejik%20Planlar/Stratejik%20Plan%202017-2021.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="block p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow border border-gray-100"
            >
              <h3 className="text-xl font-semibold text-hacettepe-blue">{t('strategic_plan.plan_2017_2021')}</h3>
            </a>

            <a 
              href="https://fs.hacettepe.edu.tr/fenyeni/dosyalar/Stratejik%20Planlar/Statejik%20Plan%202014-2018.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="block p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow border border-gray-100"
            >
              <h3 className="text-xl font-semibold text-hacettepe-blue">{t('strategic_plan.plan_2014_2018')}</h3>
            </a>

            <a 
              href="https://fs.hacettepe.edu.tr/fenyeni/dosyalar/Stratejik%20Planlar/Stratejik%20Plan%202013-2017%20(Revize).pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="block p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow border border-gray-100"
            >
              <h3 className="text-xl font-semibold text-hacettepe-blue">{t('strategic_plan.plan_2013_2017_revised')}</h3>
            </a>

            <a 
              href="https://fs.hacettepe.edu.tr/fenyeni/dosyalar/Stratejik%20Planlar/Stratejik%20Plan%202013-2017.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="block p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow border border-gray-100"
            >
              <h3 className="text-xl font-semibold text-hacettepe-blue">{t('strategic_plan.plan_2013_2017')}</h3>
            </a>
          </div>
        </div>

        <div className="flex justify-center">
          <a 
            href="https://sgdb.hacettepe.edu.tr/raporlar_stratejik_plan.shtml"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-lg font-medium rounded-md text-white bg-hacettepe-red hover:bg-hacettepe-red-dark transition-colors"
          >
            {t('strategic_plan.hacettepe_strategic_plans')}
          </a>
        </div>
      </div>
    </PageTemplate>
  );
};

export default StrategicPlan; 